import React from 'react';
import PropTypes from 'prop-types';
import { FaExclamation as ExclamationMarkIcon } from 'react-icons/fa';

const ValidationErrorCellRenderer = ({ value }) => (
  value ? <ExclamationMarkIcon className="text-danger"/> : null
);

ValidationErrorCellRenderer.propTypes = {
  value: PropTypes.string,
};

export default ValidationErrorCellRenderer;
